export default __webpack_public_path__ + "static/media/banner.d19dcb1e.png";